import { initWidget } from './widget';
import endpoints from './widget/define/endpoints';

import NavigationMenu from './widget/component/NavigationMenu';
import NewsLetterForm from './widget/component/NewsLetterForm';
import TrustpilotWebhook from './widget/component/Trustpilot/TrustpilotWebhook';
import Header from './widget/component/Header/Header';
import { UserBanner as WelfareUserBanner } from './widget/component/WelfareComponents/UserBanner';
import { ModalLikeListing } from './widget/component/modals';
import SmartSearch from './widget/component/SmartSearch/SmartSearch';
import UserTracker from './widget/component/UserTracker/UserTracker';
import BlackFridayBanner from './widget/component/BlackFriday/BlackFridayBanner';
import BrazeBanner from './widget/component/BrazeBanner/BrazeBanner';
import { HubspotInsertionButton } from './widget/component/HubspotInsertionButton';
import WishlistBridge from './widget/component/WishlistBridge/WishlistBridge';
import CircleCard from './widget/component/CircleCard/CircleCard';
import { logBrazePageview } from './widget/command/braze';
import { registerBrazeServiceWorker } from './widget/command/braze-push';

const parseBrazeActivityPrice = (rawPrice) => {
  if (!rawPrice) return undefined;

  const cleaned = String(rawPrice).trim().replace(/[^0-9,.-]/g, '');
  if (!cleaned) return undefined;

  const lastDot = cleaned.lastIndexOf('.');
  const lastComma = cleaned.lastIndexOf(',');

  let normalized;
  if (lastComma > lastDot) {
    // Comma is decimal separator (e.g. 14.999,66)
    normalized = cleaned.replace(/\./g, '').replace(',', '.');
  } else if (lastDot > lastComma) {
    // Dot is decimal separator (e.g. 14,999.66)
    normalized = cleaned.replace(/,/g, '');
  } else {
    normalized = cleaned;
  }

  const numericPrice = Number(normalized);
  return Number.isNaN(numericPrice) ? undefined : numericPrice;
};

const initCommonPageWidgets = () => {
  const props = {
    endpoints,
  };

  initWidget('header', Header, props);
  initWidget('navigation-menu', NavigationMenu, props);
  initWidget('newsletter', NewsLetterForm, props);
  initWidget('trustpilot-webhook', TrustpilotWebhook, props);
  initWidget('welfare-user-banner', WelfareUserBanner, props);
  initWidget('black-friday-banner', BlackFridayBanner, props);
  initWidget('modal-like-listing', ModalLikeListing, props);
  initWidget('user-tracker', UserTracker, props);
  initWidget('smart-search', SmartSearch, props);
  initWidget('hubspot-insertion-button', HubspotInsertionButton, props);
  initWidget('wishlist-bridge', WishlistBridge, props);
  initWidget('circle-card', CircleCard, props);
  initWidget('braze-banner', BrazeBanner, props);

  // Braze: register service worker for push notifications
  registerBrazeServiceWorker();

  // Braze: track pageview (skip on search pages — they fire search_pageview instead;
  // skip on checkout — OrderRecapCheckout / ThankYou fire an enriched pageview once cart/listing data loads)
  const cataloguePath = window.freedomeConfig?.knownPages?.catalogue;
  const checkoutPath = window.freedomeConfig?.knownPages?.checkout;
  const isSearchPage = cataloguePath && window.location.pathname.startsWith(cataloguePath);
  const isCheckoutPage = checkoutPath && window.location.pathname.startsWith(checkoutPath);

  if (!isSearchPage && !isCheckoutPage) {
    const metaCategory = document.querySelector('meta[property="product:category"]');
    const metaMacroCategory = document.querySelector('meta[property="product:custom_label_0"]');
    const metaProductType = document.querySelector('meta[name="braze:product_type"]');

    const metaActivityTitle = document.querySelector('meta[name="braze:activity_title"]');
    const metaActivityImageUrl = document.querySelector('meta[name="braze:activity_image_url"]');
    const metaActivityUrl = document.querySelector('meta[name="braze:activity_url"]');
    const metaActivityRating = document.querySelector('meta[name="braze:activity_rating"]');
    const metaActivityLocation = document.querySelector('meta[name="braze:activity_location"]');
    const metaActivityPrice = document.querySelector('meta[name="braze:activity_price"]');

    logBrazePageview(
      window.location.pathname,
      metaCategory ? metaCategory.getAttribute('content') : null,
      metaMacroCategory ? metaMacroCategory.getAttribute('content') : null,
      {
        productType: metaProductType ? metaProductType.getAttribute('content') : undefined,
        activityTitle: metaActivityTitle ? metaActivityTitle.getAttribute('content') : undefined,
        activityImageUrl: metaActivityImageUrl ? metaActivityImageUrl.getAttribute('content') : undefined,
        activityUrl: metaActivityUrl ? metaActivityUrl.getAttribute('content') : undefined,
        activityRating: metaActivityRating ? metaActivityRating.getAttribute('content') : undefined,
        activityLocation: metaActivityLocation ? metaActivityLocation.getAttribute('content') : undefined,
        activityPrice: parseBrazeActivityPrice(
          metaActivityPrice ? metaActivityPrice.getAttribute('content') : undefined
        ),
      }
    );
  }
};

if (document.readyState === 'loading') {
  document.addEventListener(
    'DOMContentLoaded',
    initCommonPageWidgets.bind(this)
  );
} else {
  initCommonPageWidgets();
}
